import React from "react";
import SharedDocumentManagement from "../../components/shared/DocumentManagement";
import { FileText, Eye, Download } from "lucide-react";

const TrusteeDocumentManagement = () => {
  const documentSections = [
    {
      id: "sub-investor-status",
      title: "Sub-Investor Status Report",
      description: "Status reports for sub-investors"
    },
    {
      id: "audited-financial",
      title: "Audited financial statements",
      description: "Audited financial statements and reports"
    },
    {
      id: "unaudited-management",
      title: "Unaudited management accounts",
      description: "Unaudited management accounts"
    },
    {
      id: "compliance-certificate",
      title: "Compliance certificate",
      description: "Compliance certificates and documentation"
    }
  ];

  return (
    <>
      {/* Header */}
      <div className="bg-white shadow">
        <div className="px-4 mx-auto max-w-7xl sm:px-6 lg:px-8">
          <div className="flex items-center justify-between py-4">
            <div>
              <h1 className="text-2xl font-bold text-gray-900">
                Document Management
              </h1>
              <p className="text-sm text-gray-500">
                Manage trustee and bond related documents 
              </p>
            </div>
          </div>
        </div>
      </div>



      {/* Bond Documents Section */}
      <SharedDocumentManagement role="trustee" />
    </>
  );
};

export default TrusteeDocumentManagement;
